export enum PurchaseOrderBillingStatus {
  NotBilled = 'not_billed',
  PartiallyBilled = 'partially_billed',
  Billed = 'billed',
}
